<template>
    <div id="notFound">
        404-Not Found
    </div>
</template>
<script>
    export default {
        name: 'notFound',
        data() {
            return {}
        }
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/common/NotFound.vue